// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"630":"f3ec8948","704":"163f42f2","833":"5d3595bd","836":"183c83d1"}[chunkId] + ".chunk.css";
};